export const iconFontAwesomeFilesFloppyDisk = (
	<i className="fa-solid fa-floppy-disk"></i>
);
